import { render, staticRenderFns } from "./FollowUp.vue?vue&type=template&id=2fed8c50&scoped=true"
import script from "./FollowUp.vue?vue&type=script&lang=js"
export * from "./FollowUp.vue?vue&type=script&lang=js"
import style0 from "./FollowUp.vue?vue&type=style&index=0&id=2fed8c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fed8c50",
  null
  
)

export default component.exports